import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

// Define language options with country flags
const languageOptions = [
  {
    value: "en",
    label: (
      <div className="flex items-center">
        <img
          src="https://flagcdn.com/w40/gb.png" // Saudi Arabia flag
          alt="Saudi Arabia"
          className="w-6 h-4 mr-2"
        />
        English
      </div>
    ),
  },
  {
    value: "ar",
    label: (
      <div className="flex items-center">
        <img
          src="https://flagcdn.com/w40/sa.png" // Saudi Arabia flag
          alt="Saudi Arabia"
          className="w-6 h-4 mr-2"
        />
        العربية
      </div>
    ),
  },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleChange = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value);
  };

  return (
    <Select
      options={languageOptions}
      defaultValue={languageOptions.find((opt) => opt.value === i18n.language)}
      onChange={handleChange}
      className="w-48"
      isSearchable={false}
    />
  );
};

export default LanguageSelector;
